import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material/styles';

const Desk = (props) => {
   const theme = useTheme();
   return (
      <SvgIcon {...props} viewBox="0 0 40 40">
         <g
            id="ITO-Design-System"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
         >
            <g
               id="desk"
               transform="translate(-0.2369, 0)"
               fill={theme.palette.primary.main}
               fillRule="nonzero"
            >
               <path d="M34.6664 9.72973C35.0663 9.72973 35.3335 9.99281 35.3336 10.3875V22.2329C35.3335 22.6276 35.0663 22.8906 34.6664 22.8906H28.6666V25.5226H34.0002V24.2071H36.667V25.5226H39.3338C39.7336 25.5228 40 25.7867 40 26.1814V40H38.6666V30.1288H37.3332V40H35.9998V30.1288H4.00021V40H2.66681V30.1288H1.3334V40H0V26.1814C0 25.7867 0.266448 25.5228 0.666174 25.5226H4.00021V24.2071H3.33298C2.93318 24.207 2.66681 23.9431 2.66681 23.5484V20.9164C2.66689 20.5218 2.93324 20.2588 3.33298 20.2587H4.00021V18.2844C4.00021 17.8897 4.26654 17.6268 4.66638 17.6267H13.333C13.733 17.6267 14.0002 17.8896 14.0002 18.2844V20.9164C14.0002 21.3112 13.733 21.5741 13.333 21.5741H12.6668V22.8906H13.333C13.7328 22.8906 14 23.1538 14.0002 23.5484V25.5226H23.333V22.8906H17.3332C16.9333 22.8906 16.6671 22.6276 16.667 22.2329V10.3875C16.6672 9.99285 16.9334 9.72979 17.3332 9.72973H34.6664ZM1.3334 26.8391V28.8133H38.6666V26.8391H1.3334ZM5.33361 25.5226H12.6668V24.2071H5.33361V25.5226ZM24.6664 25.5226H27.3332V22.8906H24.6664V25.5226ZM4.00021 22.8906H11.3334V21.5741H4.00021V22.8906ZM18.0004 21.5741H34.0002V19.6009H18.0004V21.5741ZM5.33361 20.2587H12.6668V18.9421H5.33361V20.2587ZM18.0004 18.2844H34.0002V11.0462H18.0004V18.2844Z" />
               <path d="M9.32432 0V4.62416H11.3514C12.8378 4.62416 14.0541 5.81428 14.0541 7.26774V11.231C14.0541 11.6274 13.7838 11.8919 13.3784 11.8919H3.91892C3.51351 11.8919 3.24324 11.6274 3.24324 11.231V7.26774C3.24324 5.81428 4.45946 4.62416 5.94595 4.62416H7.97297V0H9.32432ZM5.94595 5.94595C5.2027 5.94595 4.59459 6.54101 4.59459 7.26774V7.92758H7.97297V9.24937H4.59459V10.5701H12.7027V7.26774C12.7027 6.54101 12.0946 5.94595 11.3514 5.94595H5.94595Z" />
            </g>
         </g>
      </SvgIcon>
   );
};
export default Desk;
